import { Injectable } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { HubConnectionBuilder } from '@microsoft/signalr';
import { Subject } from "rxjs";
import { AuthService } from "../../auth/_services/auth.service";
import { RefreshTokenService } from "../../auth/_services/refresh-token.service";
import { CustomHttpClient } from "../../core/services/custom-http-client";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class SignalrService {

  hubConnection!: signalR.HubConnection;
  ticketReceived = new Subject<number>();
  globalTicketNotification = new Subject();
  unAssignmentTicketNotification = new Subject();
  newAnswerToClosedTicketNotification = new Subject();
  messageReceived = new Subject<number>();
  messageCountChanged = new Subject<any>();
  userRegistered = new Subject<any>();
  profileCompleted = new Subject<any>();
  connectRequestSent = new Subject<any>();
  connectionEstablished = new Subject<any>();
  homeWorkSubmitted = new Subject<any>();
  homeWorkEvaluated = new Subject<any>();

  token;
  events = [
    {
      name: 'message',
      subject: this.messageReceived
    },
    {
      name: 'messageCount',
      subject: this.messageCountChanged
    },
    {
      name: 'userRegistered',
      subject: this.userRegistered
    },
    {
      name: 'profileCompleted',
      subject: this.profileCompleted
    },
    {
      name: 'connectRequestSent',
      subject: this.connectRequestSent
    },
    {
      name: 'connectionEstablished',
      subject: this.connectionEstablished
    },
    {
      name: 'homeWorkSubmitted',
      subject: this.homeWorkSubmitted
    },
    {
      name: 'homeWorkEvaluated',
      subject: this.homeWorkEvaluated
    },
  ];

  constructor(
    // private platform: Platform,
    private refreshTokenService: RefreshTokenService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.token = localStorage.getItem('token') as string;
  }

  connect() {
    this.buildConnection();
    this.hubConnection.serverTimeoutInMilliseconds = 1800000;
    this.startConnection();
    // if (this.platform.isBrowser)
    Notification.requestPermission();
  }

  private buildConnection = () => {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(environment.notificationHubUrl, {
        httpClient: new CustomHttpClient(this.authService),
        accessTokenFactory: () => localStorage.getItem('token') as string
      })
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect()
      .build();
  }


  private startConnection = () => {

    this.hubConnection
      .start()
      .then(() => {
        this.events.forEach(x => {
          this.hubConnection.on(x.name, (data: any) => {
            x.subject.next(data);
          });
        });
        this.hubConnection.invoke('Connected', this.authService.currentUserValue.id, localStorage.getItem('tenantId'));
      })
      .catch((err) => {
        console.log(err);
      })
  }

  stopConnection = () => {
    this.hubConnection?.stop();
    this.events.forEach(x => {
      this.hubConnection?.off(x.name, (data: any) => {
        x.subject.next(data);
      });
    });
  }


  getConnectionId() {
    return this.hubConnection.connectionId;
  }
}


